import React, { useEffect, useState } from "react";
import './NewCollections.css'
import Item from '../Item/Item';

const NewCollections = () => {
    const [new_collection, setNew_collection] = useState([]);

    useEffect(() => {
        fetch('/api/newcollection')
            .then((response) => response.json())
            .then((data) => setNew_collection(data));
    }, []);
    
    return (
        // Use a <section> tag and the .container utility class
        <section className="new-collections container">
            <h1>Latest Additions</h1>
            
            {/* The product grid container */}
            <div className="new-collections__grid">
                {new_collection.map((item) => (
                    <Item 
                        key={item.id} 
                        id={item.id} 
                        name={item.name} 
                        image={item.image} 
                        new_price={item.new_price} 
                        old_price={item.old_price} 
                    />
                ))}
            </div>
        </section>
    );
}

export default NewCollections;